import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-community';

@Component({
  standalone: true,
  selector: 'app-ag-grid-loading-overlay',
  templateUrl: './ag-grid-loading-overlay.component.html',
  styleUrls: ['./ag-grid-loading-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('200ms ease-out', style({ opacity: 0 }))]),
    ]),
  ],
})
export class AgGridLoadingOverlayComponent implements ILoadingOverlayAngularComp {
  protected readonly rows = signal([]);

  agInit(params: ILoadingOverlayParams & { rows: number }): void {
    this.rows.set(Array.from({ length: params.rows }));
  }
}
